<template>
    <div v-show="visible">
        <el-dialog title="修改" :visible.sync="visible" :close-on-click-modal="false" :before-close="dialogClose" width="65%">
            <el-form ref="form" :model="form" :rules="rules" label-width="85px">
                <div style="font-size:14px;margin-bottom:10px;font-weight:bold;">基本信息：</div>
                <el-row :gutter="15">
                    <el-col :lg="8" :xl="11">
                        <el-form-item prop="name" label="姓名">
                            <el-input v-model="form.name" maxlength="50"></el-input>
                        </el-form-item>
                    </el-col>

                    <el-col :lg="8" :xl="11">
                        <el-form-item prop="deptId" label="所属机构">
                            <el-cascader
                                :options="depts"
                                v-model="form.deptId"
                                :props="props"
                                @change="onDeptChange"
                                collapse-tags
                                clearable></el-cascader>
                        </el-form-item>
                    </el-col>

                    <el-col :lg="8" :xl="11">
                        <el-form-item prop="roleId" label="角色">
                            <el-cascader
                                :options="roles"
                                v-model="form.roleId"
                                :props="props"
                                collapse-tags
                                clearable></el-cascader>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="15">
                    <el-col :lg="8" :xl="11">
                        <el-form-item prop="sex" label="性别">
                            <el-select v-model="form.sex" clearable placeholder="请选择">
                                <el-option v-for="item in sexs" :key="item.value" :label="item.label" :value="item.value"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>

                    <el-col :lg="8" :xl="11">
                        <el-form-item prop="identityCard" label="身份证">
                            <el-input v-model="form.identityCard" :readonly="true" maxlength="50"></el-input>
                        </el-form-item>
                    </el-col>

                    <el-col :lg="8" :xl="11">
                        <el-form-item prop="status" label="岗位状态">
                            <el-select v-model="form.status" clearable placeholder="请选择">
                                <el-option v-for="item in statuss" :key="item.value" :label="item.label" :value="item.value"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="15">
                    <el-col :lg="8" :xl="11">
                        <el-form-item prop="postId" label="岗位">
                            <el-select v-model="form.postId" clearable placeholder="请选择">
                                <el-option v-for="item in posts" :key="item.id" :label="item.name" :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>

                    <el-col :lg="8" :xl="11">
                        <el-form-item prop="postDescrible" label="职责描述">
                            <el-input v-model="form.postDescrible" maxlength="200"></el-input>
                        </el-form-item>
                    </el-col>

                    <el-col :lg="8" :xl="11">
                        <el-form-item prop="office" label="办公室地点">
                            <el-input v-model="form.office" maxlength="100"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="15">
                    <el-col :lg="8" :xl="11">
                        <el-form-item prop="expertise" label="有何专长">
                            <el-input v-model="form.expertise" maxlength="100"></el-input>
                        </el-form-item>
                    </el-col>

                    <el-col :lg="8" :xl="11">
                        <el-form-item prop="hobby" label="爱好">
                            <el-input v-model="form.hobby" maxlength="100"></el-input>
                        </el-form-item>
                    </el-col>

                    <el-col :lg="8" :xl="11">
                        <el-form-item prop="graduationDate" label="毕业年月">
                            <el-input v-model="form.graduationDate" maxlength="100"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="15">
                    <el-col :lg="8" :xl="11">
                        <el-form-item prop="graduationSchool" label="毕业学校">
                            <el-input v-model="form.graduationSchool" maxlength="100"></el-input>
                        </el-form-item>
                    </el-col>

                    <el-col :lg="8" :xl="11">
                        <el-form-item prop="orderNum" label="排序号">
                            <el-input v-model="form.orderNum" maxlength="100" type="number"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <div style="font-size:14px;margin-bottom:10px;font-weight:bold;">通讯信息：</div>
                <el-row :gutter="15">
                    <el-col :lg="8" :xl="11">
                        <el-form-item prop="mobile1" label="移动电话">
                            <el-input v-model="form.mobile1" maxlength="100"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="8" :xl="11">
                        <el-form-item prop="mobile2" label="办公室电话">
                            <el-input v-model="form.mobile2" maxlength="100"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="8" :xl="11">
                        <el-form-item prop="email" label="邮箱">
                            <el-input v-model="form.email" maxlength="100"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="visible=false">取消</el-button>
                <el-button type="primary" :loading="loading" @click="save()">确定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import http from '../../../../common/http';

    export default {
        data(){
            return{
                loading:false,
                visible: false,
                props: { multiple: true,  checkStrictly: true },
                depts:[],
                roles:[],
                roleId:"",
                deptId:"",
                posts:[],
                sexs:[{
                    value: 1,
                    label: '男'
                }, {
                    value: 2,
                    label: '女'
                }],
                statuss:[{
                    value: 1,
                    label: '正式'
                }, {
                    value: 2,
                    label: '试用'
                }, {
                    value: 3,
                    label: '临时'
                }],
                form:{
                    id:"",
                    username:"",
                    name:"",
                    postId:"",
                    roleId:"",
                    deptId:"",
                    sex:"",
                    identityCard:"",
                    status:"",
                    postDescrible:"",
                    office:"",
                    expertise:"",
                    hobby:"",
                    graduationDate:"",
                    graduationSchool:"",
                    orderNum:"1",
                    mobile1:"",
                    mobile2:"",
                    email:"",
                },
                rules: {
                    name: [
                        { required: true, message: '请输入姓名', trigger: 'blur' }
                    ],
                    deptId: [
                        {type: 'array', required: true, message: '请选择机构', trigger: 'blur' }
                    ],
                    mobile1:[
                        { validator: this.checkPhone, trigger: 'blur' }
                    ],
                    email:[
                        { type: 'email', message: '邮箱地址格式有误', trigger: 'blur' }
                    ]
                }
            }
        },
        methods:{
            init(row){
                this.visible=true;
                if (this.$refs['form'] != undefined) {
                    this.$refs['form'].resetFields();
                }

                let url  = this.getUserUrl
                let reqData = { id: row.id }
                this.apiPost(url,reqData).then((res) => {
                    if(res.status==200){
                        let tempData = res.data
                        this.form.id = tempData.id;
                        this.form.username = tempData.username;
                        this.form.name = tempData.name == null?"":tempData.name;
                        this.form.postId = tempData.postId== null?"":tempData.postId;
                        this.roleId = tempData.roleIdstr== null?"":tempData.roleIdstr;
                        this.deptId = tempData.deptIdstr== null?"":tempData.deptIdstr;
                        this.form.sex = tempData.sex== null?"":tempData.sex;
                        this.form.identityCard = tempData.identityCard== null?"":tempData.identityCard;
                        this.form.status = tempData.status== null?"":tempData.status;
                        this.form.postDescrible = tempData.postDescrible== null?"":tempData.postDescrible;
                        this.form.office = tempData.office== null?"":tempData.office;
                        this.form.expertise = tempData.expertise== null?"":tempData.expertise;
                        this.form.hobby = tempData.hobby== null?"":tempData.hobby;
                        this.form.graduationDate = tempData.graduationDate== null?"":tempData.graduationDate;
                        this.form.graduationSchool = tempData.graduationSchool== null?"":tempData.graduationSchool;
                        this.form.orderNum = tempData.orderNum== null?"1":tempData.orderNum;
                        this.form.mobile1 = tempData.mobile1== null?"":tempData.mobile1;
                        this.form.mobile2 = tempData.mobile2== null?"":tempData.mobile2;
                        this.form.email = tempData.email== null?"":tempData.email;
                    }else{
                        this.$commonFn.showTip(res.message,3)
                    }
                    
                    this.getDeptCascader()
                    this.getRoles()
                    this.getPosts()
                },(err)=>{
                    console.log(err)
                })
            },
            dialogClose(done){
                done();
                this.$reload;
            },
            async checkPhone(rule,value,callback){
                const phoneReg = /^1[2|3|4|5|6|7|8|9][0-9]{9}$/
                if(this.$util.isEmpty(value)){
                    callback();
                    return;
                }
                if (phoneReg.test(value)) {
                    callback()
                } else {
                    callback(new Error('移动电话格式不正确'))
                }
            },
            filterDeptOptions(options){
                if(!options || !options.length){
                    return []
                }
                const result = []
                for(let i = 0;i < options.length;i++){
                    const node = options[i]
                    const children = this.filterDeptOptions(node.children || [])
                    const label = (node.label || '').toString()
                    const isGradeNode = label.indexOf('年级') > -1 || label.indexOf('不在班学生组') > -1
                    const keep = node.parentId == 0 || !isGradeNode
                    if(keep){
                        const copy = Object.assign({}, node)
                        copy.children = children
                        result.push(copy)
                    }else{
                        for(let j = 0;j < children.length;j++){
                            result.push(children[j])
                        }
                    }
                }
                return result
            },
            getDeptCascader(){
                let url  = this.getDeptCascaderUrl;
                let data = {};
                this.apiPost(url,data).then((res) => {
                    if(res.status == 200){
                        this.depts = this.filterDeptOptions(res.data.selects); 
                        this.form.deptId = this.getName(this.deptId, this.depts);
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                });
            },
            onDeptChange(){
                // 修改所属机构后更新角色/岗位数据源
                this.deptId = this.filterCascader(this.form.deptId)
                this.getRoles()
                this.getPosts()
            },
            getRoles(){
                let url  = this.getRoleCascaderUrl;
                let data = { 'deptId':this.deptId };
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                        this.roles = res.data.selects; 
                        this.form.roleId = this.getName(this.roleId, this.roles);
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                });
            },
            getPosts(){
                let url  = this.listPostUrl;
                let data = { 'deptId':this.deptId };
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                        this.posts = res.data.posts; 
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                });
            },
            save(){
                this.$refs['form'].validate((valid) => {
                    let roleId= this.filterCascader(this.form.roleId); 
                    let deptId= this.filterCascader(this.form.deptId); 
                    if(valid){
                        this.loading=true;
                        let url= this.userUpdateUrl;
                        let data = {
                            id:this.form.id,
                            username:this.form.username,
                            name:this.form.name,
                            postId:this.form.postId,
                            personType:2,
                            roleId:roleId,
                            deptIdstr:deptId,
                            sex:this.form.sex,
                            identityCard:this.form.identityCard,
                            status:this.form.status,
                            postDescrible:this.form.postDescrible,
                            office:this.form.office,
                            expertise:this.form.expertise,
                            hobby:this.form.hobby,
                            graduationDate:this.form.graduationDate,
                            graduationSchool:this.form.graduationSchool,
                            orderNum:this.$util.isNotEmpty(this.form.orderNum)?this.form.orderNum:"",
                            mobile1:this.form.mobile1,
                            mobile2:this.form.mobile2,
                            email:this.form.email
                        };
                        this.apiPost(url, data).then((res) => {
                            if(res.status === 200){
                                this.$commonFn.showTip(res.message,1);
                                this.visible=false;
                                this.$parent.getData();
                            }else{
                                this.$commonFn.showTip(res.message,3);
                            }
                            this.loading=false;
                        }, (err) => {
                            console.log(err);
                            this.loading=false;
                        });
                    }
                });
            },
            getName(setVal,data){
                var arr = new Array();
                if(this.$util.isNotEmpty(data) && this.$util.isNotEmpty(setVal)){
                    let valArr = setVal.split(",");
                    for(let i = 0;i < valArr.length;i++){
                        var tempArr = new Array();
                        this.recursionCascader(valArr[i], data, tempArr, data);
                        arr.push(tempArr.reverse());
                    }
                }
                return arr;
            },
            recursionCascader(val, cdata, tempArr, data){
                if(val == 0){
                    return;
                }
                for(let i=0; i<cdata.length;i++){
                    if(cdata[i].value == val){
                        tempArr.push(val);
                        this.recursionCascader(cdata[i].parentId, data, tempArr, data);
                    }
                    if(cdata[i].children && cdata[i].children.length) {
                        this.recursionCascader(val, cdata[i].children, tempArr, data);
                    }
                }
            },
            filterCascader(data){
                let arrVal = new Array();
                for(let i=0; i<data.length;i++){
                    arrVal.push(data[i][data[i].length-1]);
                }
                return arrVal.join();
            }
        },
        mixins: [http]
    }
</script>

<style scoped>
</style>




// WEBPACK FOOTER //
// src/components/page/sys/teacher/TeacherUpdate.vue